import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Dashboard from '../../components/layout/Dashboard';
import { useAuth } from '../../context/AuthContext';
import { authApi } from '../../api/authApi';

const ToolsOverviewPage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    const [tools, setTools] = useState([]);
    const [loading, setLoading] = useState(true);

    const toolInfo = {
        timesheet: { name: 'Stundennachweis', description: 'Arbeitsstunden erfassen', icon: '⏱️', color: '#667eea' },
        journal: { name: 'Bautagebuch', description: 'Tägliche Berichte', icon: '📔', color: '#764ba2' },
        vehicleStatus: { name: 'Fahrzeugstatus', description: 'Fahrzeuge verwalten', icon: '🚗', color: '#f093fb' },
        leader: { name: 'Kolonnenführer', description: 'Teammanagement', icon: '👥', color: '#4facfe' },
        employee: { name: 'Mitarbeiterverwaltung', description: 'Team verwalten', icon: '🧑‍💼', color: '#34c759' },
        photos: { name: 'Fotonachweis', description: 'Dokumentation', icon: '📷', color: '#fa709a' },
        files: { name: 'Dateiablage', description: 'Dokumente', icon: '📁', color: '#30cfd0' },
        internalHandover: { name: 'Interne Übergabe', description: 'Material & Info Übergabe', icon: '🔄', color: '#f6d365' },
        rental: { name: 'Vermietung', description: 'Mieten & Rechnungen', icon: '🚧', color: '#ff9a9e' },
    };

    useEffect(() => {
        const isSuperAdmin = (user?.username === 'info@opti-mox.de') || (user?.email === 'info@opti-mox.de');

        if (user && !isSuperAdmin) {
            fetchUserTools();
        } else {
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const fetchUserTools = async () => {
        try {
            const data = await authApi.getMyTools();

            const mappedTools = data
                .filter((tool) => tool.granted && !['employee', 'vehicleStatus'].includes(tool.tool_key))
                .map((tool) => ({
                    id: tool.tool_key,
                    name: toolInfo[tool.tool_key]?.name || tool.tool_name,
                    description: toolInfo[tool.tool_key]?.description || '',
                    icon: toolInfo[tool.tool_key]?.icon || '🛠️',
                    color: toolInfo[tool.tool_key]?.color || '#667eea',
                }));

            setTools(mappedTools);
        } catch (err) {
            console.error('Error fetching tools:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleToolSelect = (toolId) => {
        navigate(`/tools/${toolId}`, { state: { from: '/tools' } });
    };



    return (
        <div className="tools-overview-container">
            <Dashboard user={user} onToolSelect={handleToolSelect} tools={tools} loading={loading} />
        </div>
    );
};

export default ToolsOverviewPage;
